import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useAuthStore } from "../../../store/auth.store";
import { PartnerApi } from "../../../api/partner.api";
import ProductsCatalog from "../../Products/ProductsCatalog";
import { useLoanVendorProducts } from "../../../hook/partner/loanVendorProducts.partner.hook";
import { useLoanVendors } from "../../../hook/partner/loanVendors.partner.hook";
import { useLoanVendorProductAvailability } from "../../../hook/partner/loanVendorProductAvailability.partner.hook";
import { useLoansStore } from "../../../store/loans.store";
import number_format from "../../../utils/number_format";
import LoanAddItemAvailabilityModal from "../../modals/loan/LoanAddItemAvailabilityModal";
import LoanAddItemAvailabilityForm from "./LoanAddItemAvailabilityForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function LoanAddItemForm({
                                          handleClose,
  loan_id,
  callback,
  loan_from,
  loan_to,
}) {
  const { t } = useTranslation();
  const [errorAddProduct, setErrorAddProduct] = useState(null);
  const [selectedLoanVendor, setSelectedLoanVendor] = useState(null);
  const [selectedLoanVendorProduct, setSelectedLoanVendorProduct] =
    useState(null);
  const loanVendorProductsMutation = useLoanVendorProducts();
  const loanVendorMutation = useLoanVendors();

  const token = useAuthStore((state) => state.token);

  const loanVendors = useLoansStore((state) => state.loanVendors);
  const loanVendorProducts = useLoansStore((state) => state.loanVendorProducts);

  useEffect(() => {
    if (token) {
      loanVendorMutation.mutate({ token: token });
    }
  }, [token]);

  useEffect(() => {
    if (token && selectedLoanVendor) {
      loanVendorProductsMutation.mutate({
        token: token,
        id: selectedLoanVendor,
      });
    }
  }, [token, selectedLoanVendor]);

  return (
    <>
      {errorAddProduct && (
        <p className="alert alert-danger">{errorAddProduct}</p>
      )}
      <div className="mb-10">
        <div style={{ maxHeight: "60vh", overflow: "auto" }}>
          <div className="menu menu-rounded menu-column menu-gray-600 menu-state-bg fw-semibold">
            {selectedLoanVendor === null ? (
              loanVendors?.length > 0 && (
                <div xstyle={{ maxHeight: "60vh", overflow: "visible" }}>
                  <h3 className="mb-4">{t("loans.selectVendor")}</h3>
                  <div className="row" style={{ width: "100%" }}>
                    {loanVendors?.map((loanVendor) => (
                      <div className="col-4">
                        <div
                          className={"cursor-pointer"}
                          onClick={() =>
                            setSelectedLoanVendor(loanVendor.vendor_id)
                          }
                        >
                          <div
                            className={
                              "card p-5 d-flex justify-content-center align-items-center h-100"
                            }
                          >
                            <img
                              className="mw-100"
                              style={{
                                aspectRatio: "1 / 1",
                                objectFit: "contain",
                              }}
                              src={
                                PartnerApi.url +
                                "/vendor/" +
                                loanVendor.vendor_id +
                                "/logo.jpg"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )
            ) : loanVendorProductsMutation.isLoading ? (
              <div className="alert alert-primary">{t("common.loading")}...</div>
            ) : (
              <>
                <button
                  className={"btn btn-primary btn-sm"}
                  onClick={() => setSelectedLoanVendor(null)}
                >
                  {t("loans.backToVendors")}
                </button>
                {loanVendorProducts?.length > 0 && (
                  <div className="pt-3">
                    {loanVendorProducts.map((p) => (
                      <div className="border-top">
                        <div
                          className={"p-2"}
                          style={
                            selectedLoanVendorProduct === p.product.product_id
                              ? {
                                  backgroundColor: "#efefef",
                                  borderRadius: "10px",
                                  border: "solid 1px #aaa",
                                }
                              : null
                          }
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="flex-fill">
                              <div style={{ padding: "10px" }}>
                                <div className="me-3">
                                  <strong>{p.product.product_type}</strong>
                                  <br />
                                  <span>{p.product.name}</span>
                                </div>
                                <div>
                                  <span className="badge badge-secondary">
                                    {p.product.sku}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div>
                              <button
                                className="btn btn-primary btn-sm text-nowrap"
                                onClick={() =>
                                  setSelectedLoanVendorProduct(
                                    p.product.product_id
                                  )
                                }
                              >
                                {t("loans.checkAvailability")}
                              </button>
                            </div>
                          </div>
                          {selectedLoanVendorProduct ===
                            p.product.product_id && (
                            <LoanAddItemAvailabilityForm
                                handleClose={handleClose}
                              callback={callback}
                              loan_id={loan_id}
                              vendor_id={selectedLoanVendor}
                              product_id={p.product.product_id}
                              loan_from={loan_from}
                              loan_to={loan_to}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
